import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import { Layout } from './components/Layout';
import { LandingPage } from './pages/LandingPage';
import { DiscoverPage } from './pages/DiscoverPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { SubmitProjectPage } from './pages/SubmitProjectPage';
import { LoginPage, SignupPage } from './pages/AuthPages';
import { AuthCallback } from './pages/AuthCallback';
import { ProfilePage } from './pages/ProfilePage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { MessagesPage } from './pages/MessagesPage';
import { FollowingFeedPage } from './pages/FollowingFeedPage';
import { EditProfilePage } from './pages/EditProfilePage';
import { LegalPage } from './pages/LegalPage';
import './App.css';

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id (Google OAuth callback)
  // This must happen BEFORE ProtectedRoute runs to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public routes without layout */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />

      {/* Routes with layout */}
      <Route path="/" element={<Layout><LandingPage /></Layout>} />
      <Route path="/discover" element={<Layout><DiscoverPage /></Layout>} />
      <Route path="/project/:id" element={<Layout><ProjectDetailPage /></Layout>} />
      <Route path="/submit" element={<Layout><SubmitProjectPage /></Layout>} />
      <Route path="/profile/:userId" element={<Layout><ProfilePage /></Layout>} />
      <Route path="/leaderboard" element={<Layout><LeaderboardPage /></Layout>} />
      <Route path="/admin" element={<Layout><AdminDashboard /></Layout>} />
      <Route path="/messages" element={<Layout><MessagesPage /></Layout>} />
      <Route path="/messages/:conversationId" element={<Layout><MessagesPage /></Layout>} />
      <Route path="/feed" element={<Layout><FollowingFeedPage /></Layout>} />
      <Route path="/settings/profile" element={<Layout><EditProfilePage /></Layout>} />
      <Route path="/page/:slug" element={<Layout><LegalPage /></Layout>} />

      {/* 404 fallback */}
      <Route path="*" element={
        <Layout>
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-slate-900 mb-2">404</h1>
              <p className="text-slate-600">Page not found</p>
            </div>
          </div>
        </Layout>
      } />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <SiteSettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AuthProvider>
      </SiteSettingsProvider>
    </LanguageProvider>
  );
}

export default App;
